module.exports = __webpack_public_path__ + "img/by-nc.431810d6.png";